import React from 'react';
import PropTypes from 'prop-types';
import JSONLD from 'react-structured-data/dist/JSONLD';
import { Generic, GenericCollection } from 'react-structured-data/dist/schemas';

export default function ItemList({ landingPageUrl, title, description, cuisine, items }) {
  return (
    <JSONLD dangerouslyExposeHtml>
      <Generic
        type="ItemList"
        schema={{
          '@type': 'ItemList',
          name: title,
          description,
          itemListOrder: 'http://schema.org/ItemListOrderAscending',
        }}
      >
        <GenericCollection type="itemListElement">
          {items.map(({ props }, index) => {
            const {
              name,
              imageUrl,
              ratingPercent,
              ratingCount: ratingCountText,
              priceText,
              locationText,
            } = props;
            const ratingValue = ((ratingPercent / 100) * 5).toFixed(1);
            const ratingCount = ratingCountText > 50 ? '50+' : parseInt(ratingCountText, 10);

            return (
              <Generic
                key={name}
                jsonldtype="ListItem"
                schema={{
                  position: index + 1,
                  item: {
                    url: `${landingPageUrl}#${index + 1}`,
                    name,
                    '@type': 'Restaurant',
                    servesCuisine: cuisine,
                    priceRange: priceText,
                    image: imageUrl,
                    address: locationText,
                    aggregateRating: ratingValue
                      ? {
                          bestRating: 5,
                          ratingValue,
                          ratingCount,
                        }
                      : undefined,
                  },
                }}
              />
            );
          })}
        </GenericCollection>
      </Generic>
    </JSONLD>
  );
}

ItemList.propTypes = {
  landingPageUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  cuisine: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      props: PropTypes.shape,
      key: PropTypes.string,
    }),
  ).isRequired,
};
